import * as fromStandardEntity from '@app/shared/store/standard-entity.state';
import { isCognitoUser, Role } from '@cco/model';
import * as fromRole from '@core/auth/reducers/role.reducer';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentUserPrivileges, State } from './auth2.reducer';

const selectAuth2State = createFeatureSelector<State>('auth2');
export const selectCurrentUser = createSelector(selectAuth2State, state => state?.currentUser);
export const selectCurrentCognitoUser = createSelector(selectCurrentUser, (user) => {
  if (isCognitoUser(user))
    return user;

  return null;
});
export const selectCurrentTenantUser = createSelector(selectAuth2State, state => state?.currentTenantUser);
export const selectTenantUserName = createSelector(
  selectCurrentTenantUser,
  tenantUser => tenantUser && `${tenantUser.givenNames ?? ''} ${tenantUser.surname ?? ''}`
);

export interface UserHasPrivilegesProps {
  oneOf: string | string[];
  allOf: string | string[];
  allowAnonymous?: boolean;
}
export const selectUserHasPrivileges = (props: UserHasPrivilegesProps) => createSelector(
  selectCurrentUserPrivileges,
  (privileges: string[]) => {
    if (props.allowAnonymous === true) {
      return true;
    }

    props.oneOf = !props.oneOf ? [] : typeof props.oneOf === 'string' ? [props.oneOf] : props.oneOf;
    props.allOf = !props.allOf ? [] : typeof props.allOf === 'string' ? [props.allOf] : props.allOf;

    if (!privileges) {
      return false;
    }
    if (props.oneOf.length === 0 && props.allOf.length === 0) {
      return false;
    }

    let hasAtLeastOne = props.oneOf.length === 0;
    let missingAny = false;

    for (const p of props.oneOf) {
      if (privileges.includes(p)) {
        hasAtLeastOne = true;
      }
    }

    for (const p of props.allOf) {
      if (!privileges.includes(p)) {
        missingAny = true;
      }
    }

    return hasAtLeastOne && !missingAny;
  },
);
export const selectUserName = createSelector(
  selectCurrentUser,
  currentUser => `${currentUser?.givenName} ${currentUser?.familyName?.toUpperCase()}`,
);
export const selectRoleState = createFeatureSelector<fromRole.State>('role');
export const selectRoles = createSelector(selectRoleState, fromRole.selectAll);
export const selectRoleEntities = createSelector(selectRoleState, fromRole.selectEntities);
export const selectRoleErrors = createSelector(selectRoleState, fromStandardEntity.selectErrors);
export const selectRoleSaving = createSelector(selectRoleState, fromStandardEntity.selectSaving);
export const selectRoleById = (id: number) =>
  createSelector(selectRoleEntities, (roles: Dictionary<Role>) => {
    if (roles) {
      return roles[id];
    } else {
      return null;
    }
  });
export const selectRolesLoadedAll = createSelector(
  selectRoleState,
  fromStandardEntity.selectLoadedAll,
);
